import { render, staticRenderFns } from "./Seo.vue?vue&type=template&id=2a1a5db2&scoped=true"
import script from "./Seo.vue?vue&type=script&lang=js"
export * from "./Seo.vue?vue&type=script&lang=js"
import style1 from "./Seo.vue?vue&type=style&index=1&id=2a1a5db2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1a5db2",
  null
  
)

export default component.exports